import React, { useState, useEffect } from "react";
import propTypes from "prop-types";
import { createDataAttributes } from "../../utilities";

const PhoneLink = ({ phoneNumber, children, dataAttrib }) => {
  const [isMobile, setIsMobile] = useState(
    document.documentElement.clientWidth < 768
  );

  // update state when screen is resized
  useEffect(() => {
    const handler = () => {
      setIsMobile(document.documentElement.clientWidth < 768);
    };
    window.addEventListener("resize", handler);
    return () => {
      window.removeEventListener("resize", handler);
    };
  }, []);

  return isMobile ? (
    <a href={`tel:${phoneNumber}`} {...createDataAttributes(dataAttrib)}>
      {children}
    </a>
  ) : (
    <span {...createDataAttributes(dataAttrib)}>{children}</span>
  );
};

PhoneLink.propTypes = {
  phoneNumber: propTypes.string.isRequired,
  children: propTypes.oneOfType([propTypes.string, propTypes.element]),
  dataAttrib: propTypes.arrayOf(Object)
};
export default PhoneLink;
